<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <app-ds-icon name="close-x" size="icon-size-2" color="var(--color-core-neutral-7)"></app-ds-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<div class="modal-content">
  <h1 class="ds-title-4">{{ 'INVEST.performance.reportingModal.BreakdownTitle' | translate }}</h1>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    @if (hasPortfolioUpdatesFlag) {
      <div class="section-header">
        <div>
          <h2 class="ds-heading-2">{{ 'INVEST.performance.chartSettings.timeframe.title' | translate }}</h2>
          <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('timeframe')"></app-ds-icon>
        </div>
        @if (info['timeframe']) {
          <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'INVEST.performance.chartSettings.timeframe.subtitle' | translate"></p>
        }
      </div>
      <div class="section-content">
        <div class="perf-filters">
          <app-ds-tab-nav
            [tabs]="modalPerformanceFilters"
            [activeTab]="selectedRangeControl?.value"
            size="wrap"
            (tabSwitched)="onFilterChange($event)"
          ></app-ds-tab-nav>
        </div>
      </div>

      <!-- Activities -->
      <div class="section-header">
        <div>
          <h2 class="ds-heading-2">{{ 'INVEST.performance.chartEvents.Subtitle' | translate }}</h2>
          <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('portfolioChanges')"></app-ds-icon>
        </div>
        @if (info['portfolioChanges']) {
          <p
            class="ds-ui-3 ds-color-core-neutral-7"
            [innerHTML]="'INVEST.performance.chartEvents.EventsMarkTheDaysANotableChangeHappenedTo' | translate"
          ></p>
        }
      </div>
      <div class="section-content">
        <app-ds-checkbox
          formControlName="showPortfolioChanges"
          variant="box"
          [label]="'INVEST.performance.chartEvents.CheckboxLabel' | translate"
          [additionalInfo]="'INVEST.performance.chartEvents.AdditionalDescriptionText' | translate"
          (clicked)="onShowPortfolioChanges()"
        ></app-ds-checkbox>
      </div>
    }
    @if (kind !== '3a') {
      <!-- Benchmark section -->
      <div class="section-header">
        <div>
          <h2 class="ds-heading-2">{{ 'INVEST.performance.reportingModal.ProjectsTitle' | translate }}</h2>
          <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('benchmark')"></app-ds-icon>
        </div>
        @if (info['benchmark']) {
          <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'INVEST.performance.reportingModal.TooltipPrincipal' | translate"></p>
        }
      </div>

      <div class="section-content">
        <app-ds-radio-option formControlName="benchmarkVisibility" [value]="false" [selected]="benchmarkVisibilityControl?.value" variant="box">
          <ng-container ds-radio-title>{{ 'INVEST.performance.reportingModal.RadioLabel' | translate }}</ng-container>
          <ng-container ds-radio-desc>{{ 'INVEST.performance.reportingModal.AdditionalDescriptionText' | translate }}</ng-container>
        </app-ds-radio-option>

        <app-ds-radio-option formControlName="benchmarkVisibility" [value]="true" [selected]="benchmarkVisibilityControl?.value" variant="box">
          <ng-container ds-radio-title>{{ 'INVEST.performance.reportingModal.RadioLabel84' | translate }}</ng-container>
          <ng-container ds-radio-desc>{{ 'INVEST.performance.reportingModal.AdditionalDescriptionText92' | translate }}</ng-container>
        </app-ds-radio-option>
      </div>
    }

    <app-ds-button type="submit" variant="primary" width="full">{{ 'INVEST.performance.reportingModal.ButtonLabel' | translate }}</app-ds-button>
  </form>
</div>
